import type { Lists } from '@shared/model'

import { useListsStore } from '@shared/model'
import { useAdminRoutes } from '@shared/lib/routes'

interface ListsApiOptions {
  onError?: (err: unknown) => void
}

/** The read on its way, shared by every caller until it settles: the `lists` middleware starts one in the background
 *  while a page middleware awaits `ensure()`, and both must be the same request. */
let inFlight: Promise<Lists | null> | null = null

const readLists = async (options?: ListsApiOptions): Promise<Lists | null> => {
  const { $axios } = useNuxtApp()
  const url = useAdminRoutes('admin.config.lists')

  const listsStore = useListsStore()

  try {
    const { data } = await $axios.get(url!)

    const lists = data.data || null
    listsStore.setLists(lists)
    return lists
  } catch (err: unknown) {
    options?.onError?.(err)
    return null
  }
}

export const useListsApi = (options?: ListsApiOptions): Promise<Lists | null> => {
  if (inFlight) return inFlight

  const request = readLists(options).finally(() => {
    if (inFlight === request) inFlight = null
  })
  inFlight = request

  return request
}
